import type { CVT } from '@packages/models/api/cvt';

import { Typography } from '@packages/ui/shared';

import { DiagnosticResultBadge } from '../diagnostic-result-badge';

type DiagnosticCardLabelProps = {
    diagnostic: CVT;
};

/**
 * The label side of a CVT diagnostic's radio card.
 *
 * Renders the diagnostic's id beside the badge for its result.
 */
export function DiagnosticCardLabel({ diagnostic }: DiagnosticCardLabelProps) {
    return (
        <>
            <Typography variant="label">{diagnostic.diagnosticId}</Typography>

            <DiagnosticResultBadge
                diagnosticId={diagnostic.diagnosticId}
                sbrResponseData={diagnostic.sbrResponseData}
            />
        </>
    );
}
